@if (showRightSidebar()) {
  <div (click)="showRightSidebar.set(false)" class="sidebar-overlay"></div>
}
<div class="wrapper tw-h-[calc(100vh+52px)] tw-overflow-auto tw-flex tw-flex-col" data-test-id="right-sidebar-wrapper">
  <div class="close-wrapper" data-test-id="right-sidebar-close-wrapper">
    <h3 class="user-name" data-test-id="right-sidebar-user-name">{{givenName}} {{familyName}}</h3>

    <span class="close-mobile-sidebar" (click)="showRightSidebar.set(false)" data-test-id="right-sidebar-close-button">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18" stroke="#003765" stroke-width="2" stroke-linejoin="round"/>
        <path d="M6 6L18 18" stroke="#003765" stroke-width="2" stroke-linejoin="round"/>
      </svg>
    </span>
  </div>

  <p class="user-email tw-break-words" data-test-id="right-sidebar-user-email">
    @if (!userHasNoEmail) {
      {{userEmail}}
    }
  </p>

  @if (wards && wards.length > 0) {
    <p class="change-account-label" data-test-id="right-sidebar-change-account-label">{{'checkResult.changeAccountInfoLabel' | transloco}}</p>

    <div class="min-user-card" routerLink="/results/category" (click)="showRightSidebar.set(false)" data-test-id="right-sidebar-primary-user-card">
      <div class="tw-flex-1" data-test-id="right-sidebar-primary-user-card-info">
        <div class="user-info-wrapper" data-test-id="right-sidebar-primary-user-info-wrapper">
          <span class="user-avatar" data-test-id="right-sidebar-primary-user-avatar">{{givenName[0]}}{{familyName[0]}}</span>
          <span class="user-name-info" data-test-id="right-sidebar-primary-user-name-info">{{givenName}} {{familyName}}</span>
        </div>

        <span class="user-type" data-test-id="right-sidebar-primary-user-type">{{'resultsV2.primaryLabel' | transloco}}</span>
      </div>

      @if (currentUserMpiId === selectedMpiId) {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#0077AD"/>
          <path d="M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z" fill="#0077AD"/>
        </svg>
      } @else {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#0077AD"/>
        </svg>
      }
    </div>
  }

  @for (ward of wards; track $index) {
    <div class="min-user-card" (click)="wardSwitch(ward.mpiId)" [attr.data-test-id]="'right-sidebar-ward-card-' + $index">
      <div class="tw-flex-1" [attr.data-test-id]="'right-sidebar-ward-card-info-' + $index">
        <div class="user-info-wrapper" [attr.data-test-id]="'right-sidebar-ward-info-wrapper-' + $index">
          <span class="user-avatar" [attr.data-test-id]="'right-sidebar-ward-avatar-' + $index">{{ward.firstName[0]}}{{ward.lastName[0]}}</span>
          <span class="user-name-info" [attr.data-test-id]="'right-sidebar-ward-name-info-' + $index">{{ward.firstName}} {{ward.lastName}}</span>
        </div>

        <span class="user-type" [attr.data-test-id]="'right-sidebar-ward-type-' + $index">{{'resultsV2.wardLabel' | transloco}}</span>
      </div>

      @if (ward.mpiId === selectedMpiId) {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#0077AD"/>
          <path d="M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z" fill="#0077AD"/>
        </svg>
      } @else {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#0077AD"/>
        </svg>
      }
    </div>
  }

  <span class="tw-flex-1"></span>

  <ul class="links-wrapper" data-test-id="right-sidebar-links-wrapper">
    <li data-test-id="right-sidebar-account-preferences-item">
      <a [href]="baseProfileUrl" data-test-id="right-sidebar-account-preferences-link">
        <span data-test-id="right-sidebar-account-preferences-label">{{ 'header.accountPreferences' | transloco }}</span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="#0077AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
    </li>
    <li data-test-id="right-sidebar-logout-item">
      <a href="javascript:;" (click)="logout()" data-test-id="right-sidebar-logout-link">
        <span data-test-id="right-sidebar-logout-label">{{ 'header.logoutLabel' | transloco }}</span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="#0077AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
    </li>
  </ul>
</div>
